<template>
  <b-modal v-model="isShow" @hide="onClose">
    <template #modal-title>
      {{ $t('Rename Project') }}
    </template>
    <b-container fluid>
      <template v-if="isSample">
        <b-row class="mt-2 mb-4">
          <b-col> {{ $t('English') }} {{ $t('Project Name') }} </b-col>
        </b-row>
        <b-row class="mt-2 mb-4">
          <b-col>
            <b-form-input
              v-model="projectNameEn"
              type="text"
              :placeholder="$t('Project Name')"
              class="form-control-alternative"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-4">
          <b-col> {{ $t('Korean') }} {{ $t('Project Name') }} </b-col>
        </b-row>
        <b-row class="mt-2 mb-4">
          <b-col>
            <b-form-input
              v-model="projectNameKo"
              type="text"
              :placeholder="$t('Project Name')"
              class="form-control-alternative"
            />
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <b-row class="mt-2 mb-4">
          <b-col>
            <b-form-input
              v-model="projectName"
              type="text"
              :placeholder="$t('Project Name')"
              class="form-control-alternative"
            />
          </b-col>
        </b-row>
      </template>
    </b-container>
    <template #modal-footer="{ ok }">
      <div class="w-100">
        <div class="float-right">
          <b-button
            variant="danger"
            size="sm"
            @click="rename"
            :disabled="!renameButtonEnable"
          >
            {{ $t('Rename') }}
          </b-button>
          <b-button variant="primary" size="sm" @click="ok">
            {{ $t('Cancle') }}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'RenameProjectPopup',
  data() {
    return {
      isShow: false,
      renameHandler: undefined,
      projectName: '',
      projectNameEn: '',
      projectNameKo: '',
      isSample: false,
      originProjectName: '',
      originProject: {},
      renameButtonEnable: false
    }
  },
  computed: {
    ...mapState(['renameProjectPopupData'])
  },
  methods: {
    rename() {
      if (this.renameHandler) {
        const project = _.cloneDeep(this.originProject)
        if (this.isSample) {
          project.projectNames = {}
          project.projectNames.en = _.trim(this.projectNameEn)
          project.projectNames.ko = _.trim(this.projectNameKo)
        } else {
          project.projectName = _.trim(this.projectName)
        }
        this.renameHandler(this, project)
      }
    },
    onClose() {
      this.projectName = ''
      this.originProject = {}
      this.renameHandler = undefined
      this.renameButtonEnable = false
    },
    checkNames() {
      if (!this.isSample) return
      const projectNameEn = _.trim(this.projectNameEn)
      const projectNameKo = _.trim(this.projectNameKo)
      const originEn = _.get(this.originProject, 'projectNames.en', '')
      const originKo = _.get(this.originProject, 'projectNames.ko', '')
      this.renameButtonEnable =
        projectNameEn !== originEn || projectNameKo !== originKo
    }
  },
  watch: {
    renameProjectPopupData() {
      if (this.renameProjectPopupData.isShow) {
        const { originProject, renameHandler } = this.renameProjectPopupData
        this.isShow = true
        this.originProject = originProject
        this.isSample = originProject.type === 'sample'
        if (this.isSample) {
          this.originProjectName = ''
          this.projectNameEn = originProject.projectNames['en']
          this.projectNameKo = originProject.projectNames['ko']
        } else {
          this.originProjectName = _.trim(originProject.projectName)
          this.projectNameEn = ''
          this.projectNameKo = ''
        }
        this.projectName = this.originProjectName
        this.renameHandler = renameHandler
      } else {
        this.isShow = false
        this.projectName = ''
        this.originProjectName = ''
        this.originProject = {}
        this.renameHandler = undefined
        this.renameButtonEnable = false
      }
    },
    projectName() {
      if (this.isSample) return
      const projectName = _.trim(this.projectName)
      this.renameButtonEnable =
        projectName !== this.originProjectName && projectName.length > 0
    },
    projectNameEn() {
      this.checkNames()
    },
    projectNameKo() {
      this.checkNames()
    }
  }
}
</script>

<style scoped>
button.btn-danger {
  margin-right: 10px;
}
</style>
